var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6258 14.3293C29.5859 14.1159 29.4437 13.9358 29.2454 13.8475C26.5491 12.6502 24.575 10.6761 23.3777 7.97977C22.1734 5.26768 20.2612 3.21386 17.6904 1.85814L18.4244 1.12414C18.6816 0.866956 18.6816 0.450067 18.4244 0.192886C18.1672 -0.0642952 17.7503 -0.0642952 17.4932 0.192886L16.1075 1.57857L14.8479 2.83813L12.0041 5.68194L12.0031 5.68292L0.192886 17.4935C-0.0642952 17.7507 -0.0642952 18.1676 0.192886 18.4247C0.321641 18.5535 0.489911 18.6177 0.658511 18.6177C0.827111 18.6177 0.995711 18.5535 1.12414 18.4247L8.46647 11.0824C10.9553 12.2939 12.7994 14.1936 13.9358 16.7522C15.2697 19.7558 17.4688 21.9555 20.473 23.2898C20.5589 23.3276 20.6498 23.3464 20.74 23.3464C20.9116 23.3464 21.0799 23.2796 21.206 23.1534L29.444 14.9154C29.5971 14.762 29.6653 14.5427 29.6258 14.3293ZM21.9762 8.11511L18.8429 11.2484C17.6331 8.95449 15.8654 7.18682 13.5719 5.97699L16.2586 3.28992L16.7131 2.83549C19.0679 3.98243 20.8299 5.76031 21.9762 8.11511ZM20.6004 21.8962C18.2459 20.7496 16.4835 18.9717 15.3369 16.6172L18.4705 13.4836C19.6803 15.7772 21.4477 17.5449 23.7419 18.7547L20.6004 21.8962Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlag);
export default __webpack_public_path__ + "static/media/ic_flag.ced0aaa25a74d54157f78783f7ddb61d.svg";
export { ForwardRef as ReactComponent };